import {Spinner} from "@blueprintjs/core";

export function SmallSpinner() {
  return <Spinner size={24}/>
}